import { useTranslator } from "components/Translator"
import { ForumPage } from "components/ForumPage"
import { useRouter } from "components/Router"
import { ForumPostsList } from "domains/forum-post/ForumPostsList"

export function ClubForumSearchPage(props) {
  const translator = useTranslator()
  const router = useRouter()

  return (
    <ForumPage
      breadcrumbsItems={[
        {
          href: router.generate("app_club_forum_search"),
          label: translator.trans("club.forum.search.breadcrumbsLabel"),
        },
      ]}
      formSearch={props.formSearch}
      main={
        <ForumPostsList
          posts={props.posts}
          pagination={props.pagination}
          emptyLabel={translator.trans(
            "club.forum.search.empty",
            null,
            "pages",
          )}
        />
      }
    />
  )
}
